export const certQuery = `SELECT
    -- ================= Certificate =================
    certificate.id AS id,
    certificate.reportNumber AS certificate_reportNumber,
    certificate.ulrNumber AS certificate_ulrNumber,
    certificate.rejectedBy AS certificate_rejectedBy,
    certificate.preparedBy AS certificate_preparedBy,
    certificate.preparedDate AS certificate_preparedDate,
    certificate.reviewedBy AS certificate_reviewedBy,
    certificate.reviewedDate AS certificate_reviewedDate,
    certificate.authorizedBy AS certificate_authorizedBy,
    certificate.authorizedDate AS certificate_authorizedDate,
    certificate.status AS certificate_status,

    -- ================= Rejected By =================
    rejectedByUser.userName AS rejectedBy_userName,
    rejectedByUser.usersign AS rejectedBy_userSign,
    rejectedByEmpData.hrDesignation AS rejectedBy_hrDesignation,

    -- ================= Prepared By =================
    preparedByUser.userName AS preparedBy_userName,
    preparedByUser.usersign AS preparedBy_userSign,
    preparedByEmpData.hrDesignation AS preparedBy_hrDesignation,

    -- ================= Reviewed By =================
    reviewedByUser.userName AS reviewedBy_userName,
    reviewedByUser.usersign AS reviewedBy_userSign,
    reviewedByEmpData.hrDesignation AS reviewedBy_hrDesignation,

    -- ================= Authorized By =================
    authorizedByUser.userName AS authorizedBy_userName,
    authorizedByUser.usersign AS authorizedBy_userSign,
    authorizedByEmpData.hrDesignation AS authorizedBy_hrDesignation,

    -- ================= ObservationSheet =================
    observationSheet.id AS observationSheet_id,
    observationSheet.inwardTestId AS observationSheet_inwardTestId,
    observationSheet.testId AS observationSheet_testId,
    observationSheet.testNumber AS observationSheet_testNumber,
    observationSheet.boreHoleNo AS observationSheet_boreHoleNo,
    observationSheet.startTestingDate AS observationSheet_startTestingDate,
    observationSheet.endTestingDate AS observationSheet_endTestingDate,
    observationSheet.ulrNumber AS observationSheet_ulrNumber,
    observationSheet.totalReadings AS observationSheet_totalReading,
    observationSheet.configuration AS observationSheet_configuration,
    observationSheet.testedBy AS observationSheet_testedBy,
    observationSheet.approvedBy AS observationSheet_approvedBy,
    observationSheet.testedByDate AS observationSheet_testedByDate,
    observationSheet.approvedByDate AS observationSheet_approvedByDate,
    observationSheet.designation AS observationSheet_designation,
    observationSheet.fileAttachment AS observationSheet_fileAttachment,
    observationSheet.complianceStatus AS observationSheet_complianceStatus,
    observationSheet.additionalTestDetails AS observationSheet_additionalTestDetails,
    observationSheet.requestApproval AS observationSheet_requestApproval,
    observationSheet.status AS observationSheet_status,
    
    -- Tested By User Info
    testedByUser.userName AS testedBy_userName,
    testedByUser.usersign AS testedBy_userSign,
    testedByEmpData.hrDesignation AS testedBy_hrDesignation,

    -- ================= InwardTests =================
    inwardTests.id AS inwardTests_id,
    inwardTests.inwardId AS inwardTests_inwardId,
    inwardTests.materialId AS inwardTests_materialId,
    inwardTests.testId AS inwardTests_testId,
    inwardTests.boreHoleNo AS inwardTests_boreHoleNo,
    inwardTests.lengthOfRock AS inwardTests_lengthOfRock,
    inwardTests.locationChainageNo AS inwardTests_locationChainageNo,
    inwardTests.fromDepth AS inwardTests_fromDepth,
    inwardTests.toDepth AS inwardTests_toDepth,
    inwardTests.sampleType AS inwardTests_sampleType,
    inwardTests.sampleCondition AS inwardTests_sampleCondition,
    inwardTests.SamplingDetails AS inwardTests_SamplingDetails,
    inwardTests.lotNumber AS inwardTests_lotNumber,
    inwardTests.quantity AS inwardTests_quantity,
    inwardTests.groupId AS inwardTests_groupId,
    inwardTests.status AS inwardTests_statuse,

    -- ================= Inward =================
    inward.id AS inward_id,
    inward.jobId AS inward_jobIds,
    inward.customerName AS inward_customerName,
    inward.address AS inward_address,
    inward.inwardDate AS inward_inwardDate,
    inward.testingType AS inward_testingTypes,
    inward.disciplineId AS inward_disciplineId,
    inward.contactPerson AS inward_contactPersons,
    inward.labReferenceNo AS inward_labReferenceNo,
    inward.sampleDetails AS inward_sampleDetails,
    inward.location AS inward_locations,
    inward.principleClient AS inward_principleClient,
    inward.dispatchMode AS inward_dispatchModes,
    inward.testingStartDate AS inward_testingStartDates,
    inward.reportDeliveryDate AS inward_reportDeliveryDates,
    inward.createdBy AS inward_createdBys,
    inward.approvedBy AS inward_approvedBys,
    inward.status AS inward_statuses,

    -- ================= Job Register =================
    jobRegister.id AS jobRegister_ids,
    jobRegister.jobNumber AS jobRegister_jobNumber,
    jobRegister.jobDate AS jobRegister_jobDate,
    jobRegister.clientInitials AS jobRegister_clientInitial,
    jobRegister.workOrderNo AS jobRegister_workOrderNo,
    jobRegister.workOrderPdf AS jobRegister_workOrderPdf,
    jobRegister.reference AS jobRegister_reference,
    jobRegister.department AS jobRegister_department,
    jobRegister.clientName AS jobRegister_clientName,
    jobRegister.address AS jobRegister_addresses,
    jobRegister.contactPerson AS jobRegister_contactPersons,
    jobRegister.ContactNo AS jobRegister_contactNos,
    jobRegister.panNo AS jobRegister_panNos,
    jobRegister.gstNumber AS jobRegister_gstNumbers,
    jobRegister.principleClient AS jobRegister_principleClients,
    jobRegister.projectHodId AS jobRegister_projectHodIds,
    jobRegister.projectInchargeId AS jobRegister_projectInchargeIds,
    jobRegister.workOrderAmount AS jobRegister_workOrderAmount,
    jobRegister.workOrderValidity AS jobRegister_workOrderValiditie,
    jobRegister.siteState AS jobRegister_siteState,
    jobRegister.siteCity AS jobRegister_siteCitie,
    jobRegister.projectOwnerId AS jobRegister_projectOwnerIds,
    jobRegister.serviceId AS jobRegister_serviceId,
    jobRegister.projectName AS jobRegister_projectName,

        -- ================= Material Testings =================
    materialTestings.id AS materialTestings_id,
    materialTestings.materialId AS materialTestings_materialId,
    materialTestings.scopeType AS materialTestings_scopeType,
    materialTestings.testName AS materialTestings_testName,
    materialTestings.testMethod AS materialTestings_testMethod,
    materialTestings.rangeLower AS materialTestings_rangeLower,
    materialTestings.rangeHigher AS materialTestings_rangeHigher,
    materialTestings.muValue AS materialTestings_muValue,
    materialTestings.testValue AS materialTestings_testValue,
    materialTestings.location AS materialTestings_location,
    materialTestings.masterEquipmentId AS materialTestings_masterEquipmentId,
    materialTestings.status AS materialTestings_statuse

  FROM certificate

  -- ================= User Joins =================
  LEFT JOIN userMaster AS rejectedByUser ON certificate.rejectedBy = rejectedByUser.id
  LEFT JOIN employeeOtherData AS rejectedByEmpData ON rejectedByUser.employeeId = rejectedByEmpData.employeeId

  LEFT JOIN userMaster AS preparedByUser ON certificate.preparedBy = preparedByUser.id
  LEFT JOIN employeeOtherData AS preparedByEmpData ON preparedByUser.employeeId = preparedByEmpData.employeeId

  LEFT JOIN userMaster AS reviewedByUser ON certificate.reviewedBy = reviewedByUser.id
  LEFT JOIN employeeOtherData AS reviewedByEmpData ON reviewedByUser.employeeId = reviewedByEmpData.employeeId

  LEFT JOIN userMaster AS authorizedByUser ON certificate.authorizedBy = authorizedByUser.id
  LEFT JOIN employeeOtherData AS authorizedByEmpData ON authorizedByUser.employeeId = authorizedByEmpData.employeeId

  -- ================= Observation → InwardTests → Inward → Job =================
  LEFT JOIN observationSheet ON observationSheet.certificateId = certificate.id AND observationSheet.status != -1
  LEFT JOIN materialTestings ON materialTestings.id = observationSheet.testId
  LEFT JOIN inwardTests ON inwardTests.id = observationSheet.inwardTestId
  LEFT JOIN inward ON inward.id = certificate.inwardId
  LEFT JOIN jobRegister ON jobRegister.id = inward.jobId
  
  -- Tested By Joins
  LEFT JOIN userMaster AS testedByUser ON observationSheet.testedBy = testedByUser.id
  LEFT JOIN employeeOtherData AS testedByEmpData ON testedByUser.employeeId = testedByEmpData.employeeId`;